// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SzFv","largestCol":"styles_largestCol__38YF-","smallestCol":"styles_smallestCol__CZ_PH"};